import { httpRequest } from './httpRequest';

/**
 * @typedef {Object} Specification
 * @property {Array<FeatureType>} featureType The list of feature type descriptions.
 * @property {Map<string, AttributeType>} attributeType The map of attritue type descriptions.
 * The key to access the AttributeType si the AttributeType acronym.
 */
/**
 * @typedef {Object} FeatureType
 * @property {string} acronym The feature type acronym.
 * @property {Array<string>} [attributeType] The list of attribute type acronym which could be
 * associated with the feature type.
 * @property {number} code The feature type code.
 * @property {Array<string>} [geometry] The list of possible geometry for the feature type.
 * The possible value are: Point; Line; Area
 * @property {string} name The feature type name.
 */
/**
 * @typedef {Object} AttributeType
 * @property {string} acronym The attribute type acronym.
 * @property {number} code The attribute type code.
 * @property {Array<AttributeValue>} [enum] The possible attribute value for an attribute type.
 * @property {string} name The attribute type name.
 */
/**
 * @typedef {Object} AttributeValue
 * @property {string} name The attribute value name.
 * @property {number} code The attribute value code.
 */

/**
 * The array of pointed file properties.
 * @type {Array<string>}
 */
export const pointedFileProperties = [
  'Pictorial representation',
  'Textual description',
  'Textual description in national language',
];

const specs = {};

function loadJSON(jzon) {
  for (const type of jzon.featureType) {
    type.display = `${type.name} (${type.acronym}, ${type.code})`;
  }
  const attributes = {};
  for (const type of jzon.attributeType) {
    type.display = `${type.name} (${type.acronym}, ${type.code})`;
    attributes[type.acronym] = type;
  }
  jzon.attributeType = attributes;
  return jzon;
}

async function initSpec(specKey, specURL) {
  if (!specs[specKey]) {
    const spec = await httpRequest(specURL, { method: 'GET' }, true);
    specs[specKey] = loadJSON(await spec.json());
  }
  return specs[specKey];
}

async function getSpecImpl(specKey, specURL) {
  if (!specs[specKey]) {
    specs[specKey] = initSpec(specKey, specURL);
  }
  if (specs[specKey] instanceof Promise) {
    await specs[specKey];
  }
  return specs[specKey];
}

/**
 * Get the user specification of map features.
 * @async
 * @return {Specification} The user specification.
 */
export async function getUserSpec() {
  return getSpecImpl('USER_SPEC', '/wfs/spec/user');
}

/**
 * Get the S57 specification of map features.
 * @async
 * @return {Specification} The S57 specification.
 */
export async function getS57Spec() {
  return getSpecImpl('S57_SPEC', '/wfs/spec/s57');
}
